import { getRequest } from '@/core';
import { orders } from '@/requests';

export default async function getOrdersByStringFilterRequest(filter) {
	let url = orders.getFilterPath();
	return getRequest(url, filter);
}
